<template>
  <v-container>
    <v-form>
      <v-row>
        <v-col cols="12">
          <VuetifyGooglePlaces
            :api-key="googleApiKey"
            types="address"
            country="ca"
            placeholder="Address search"
            @placechanged="getAddressData"
            searchIcon="mdi-mail"
            clearIcon="mdi-close"
            :enable-geolocation="true"
            :enable-geocode="true"
            hint="Search your address"
          >
          </VuetifyGooglePlaces>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
            :disabled="true"
            hint="Mailing Address"
            :persistent-hint="true"
            :auto-grow="true"
            :value="addressLine1"
            :outlined="true"
            :single-line="true"
          >
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { VuetifyGooglePlaces } from "vue-google-places";

export default {
  components: { VuetifyGooglePlaces },

  data: function() {
    return {
      googleApiKey: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
      address: "",
      value: "",
      addressLine1: ""
    };
  },
  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function(addressData, placeResultData, id) {
      this.address = addressData;
      console.log("address", this.address);
      console.log("placeresultdate", placeResultData);
      console.log("id", id);
      this.addressLine1 = addressData.formatted_address;
    }
  }
};
</script>
